export const defaultArea = {
    'slug': 'south-yorkshire-and-derbyshire',
    'name': 'South Yorkshire and Derbyshire'
}

export const sitename = 'Redbrik'

export const noImage = 'https://ggfx-redbrik.s3.eu-west-2.amazonaws.com/i.prod/coming_soon_large_e7f7a501b9.jpg'
